/***
 * 创建人：
 * 时间：2020-12-28
 * 描述：选择标签组件——图像著录以及实体新增时选择
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { KmsService } from '../../kms.service';
import { SwMassageBoxService } from '../../../../librarys/serves/sw-massage-box.service';
declare var $;
@Component({
    selector: 'app-label-library',
    templateUrl: './label-library.component.html',
    styleUrls: ['./label-library.component.css']
})
export class LabelLibraryComponent implements OnInit {
    // 左侧标签分类搜索
    searchTypeName = '';

    // 左侧标签分类树数据
    tagTreeDatas = [];

    // 左侧标签分类选中ID
    parentId = '';

    // 是否显示内容
    loadingGroup = {
        treeLoading: false,  // 标签分类树是否显示加载中
        tableLoading: false  // 表格是否显示加载中
    }

    // 标签分页组件
    pageBase: any = {
        current: 1,
        size: 10
    }

    // 左侧标签名搜索
    searchTagName = '';

    // 右侧标签数据
    labelDatasList = [];

    // 抛出事件
    @Output() callback = new EventEmitter();
    constructor(
        private kmsService: KmsService,
        private message: SwMassageBoxService
    ) { }

    ngOnInit() {
        this.getTagTreeData();
        this.getLabelDatas();
    }

    // 请求标签分类树数据方法
    getTagTreeData() {
        this.tagTreeDatas = [];
        this.loadingGroup.treeLoading = true;
        let keyword = $.trim(this.searchTypeName);
        let params = {
            tagName: keyword,
        }
        this.kmsService.queryTagTree(params).subscribe(result => {
            if (result.code == 200) {
                this.loadingGroup.treeLoading = false;
                if (result.data.length == 0) {
                    if(keyword){
                        this.message.danger('当前标签分类不存在！');
                    }
                    return;
                }
                let datas = result.data
                this.tagTreeDatas = datas;
                this.tagTreeDatas.forEach(item => {
                    item['id'] = item['tagId'];
                    item['pid'] = item['parentId'] ? item['parentId'] : '0';
                    item['text'] = item['tagName'];
                });
                const rootNode = {
                    'id': '0',
                    'pid': null,
                    'text': '标签分类',
                    'tagId': '0',
                    'tagName': '标签分类'
                };
                this.tagTreeDatas.push(rootNode);
            }
        });
    }

    // 获取标签数据
    getLabelDatas() {
        const params = {
            parentId: this.parentId == '0' ? '' : this.parentId,
            current: this.pageBase.current,
            tagName: this.searchTagName,
            size: this.pageBase.size
        }
        this.kmsService.queryTagList(params).subscribe(
            data => {
                if (data.code == '200') {
                    this.pageBase = data.data;
                    this.labelDatasList = data.data.records;
                    console.log(this.labelDatasList);
                } else {
                    this.message.waring(data.msg);
                }
            }
        );
    }

    // 标签库检索enter键触发事件
    handleEnterSearch(event) {

    }

    // 标签库点击选择
    handleSelectChange(event, item) {
        console.log(event);
        console.log(item);
    }

    // 标签库下一页点击事件
    handleNextClick() {

    }

    // 确定按钮
    onSubmit() {
        
    }

    // 左侧标签点击选择事件
    handleVotedClick(event) {
        console.log(event);
    }

}
